export interface SettingsNavigationItem {
  label: string
  icon?: string
  info?: string
  path: string
  aliases?: string[]
  tags?: string[]
  children?: SettingsNavigationItem[]
}

export const settingsNavigationItemMatchesPath = (
  item: Pick<SettingsNavigationItem, 'path' | 'aliases'>,
  path: string,
): boolean => item.path === path || !!item.aliases?.includes(path)

export interface SettingsNavigationGroup {
  items: SettingsNavigationItem[]
}

export interface SettingsNavigationSearchEntry {
  pagePath: string
  pageTitle: string
  pageIcon?: string
  pageInfo?: string
  searchTags?: string[]
  kind: 'page'
}

/**
 * Turn the settings side-navigation registry into page-level search entries.
 * This complements the generated field manifest for CRUD and custom-layout
 * pages that do not use SettingsLandingPage.
 */
export function settingsNavigationSearchEntries(
  groups: SettingsNavigationGroup[],
): SettingsNavigationSearchEntry[] {
  const entries = new Map<string, SettingsNavigationSearchEntry>()

  const addItem = (item: SettingsNavigationItem) => {
    if (!entries.has(item.path)) {
      entries.set(item.path, {
        pagePath: item.path,
        pageTitle: item.label,
        pageIcon: item.icon,
        pageInfo: item.info,
        searchTags: item.tags,
        kind: 'page',
      })
    }

    item.children?.forEach(addItem)
  }

  groups.forEach((group) => group.items.forEach(addItem))
  return [...entries.values()]
}
